var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle117(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "90.13275968963725 202.45 16.477650239080006 16.635206937271562",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M98.15,206.46c2.35-.02,4.43,2.09,4.46,4.54.03,2.22-1.59,3.98-3.75,4.08-2.4.12-4.58-1.85-4.72-4.27-.14-2.28,1.77-4.34,4.02-4.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle117);
export default __webpack_public_path__ + "static/media/twinkle-1-17.895643cf51eecba1c640c8d1b37d1535.svg";
export { ForwardRef as ReactComponent };